import { useEffect } from 'react';
import {
  startNotificationsSse,
  stopNotificationsSse,
} from '@/common/notifications/sse-connection.ts';

export default function useCrossTabSse(enabled = true, sessionKey?: string) {
  useEffect(() => {
    if (!enabled) return;

    startNotificationsSse();

    return () => {
      stopNotificationsSse();
    };
  }, [enabled, sessionKey]);
}
